import { cn } from '@/lib/utils'

/**
 * The header's dropdown affordance: a **solid** triangle, pointing down when the menu is
 * closed and up when it is open.
 *
 * Solid rather than a stroked chevron because that is what the rest of the Wanderu header
 * uses — ui-react draws it with FontAwesome's `sort-desc`/`sort-asc` pair, so a stroked
 * icon here would make the two headers visibly different controls at a glance. Inlined as
 * one path rather than pulled from an icon set: it is a triangle, and matching a specific
 * glyph matters more than the convenience of a named import.
 *
 * Rotated rather than swapped for a second path, so the open state animates the way the
 * rest of the chrome's disclosure affordances do. Always decorative: the control it sits
 * in carries the accessible name, and `<details>` announces its own expanded state.
 */
export function DropdownCaret({ className }: { className?: string }) {
    return (
        <svg
            viewBox="0 0 1792 1792"
            className={cn('ml-1 size-3 fill-current', className)}
            aria-hidden="true"
            focusable="false"
        >
            <path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z" />
        </svg>
    )
}
